import { jsx as _jsx } from "react/jsx-runtime";
const variantClasses = {
    default: 'bg-surface border border-border-default',
    glass: 'glass-surface',
};
export function Card({ children, className = '', variant = 'default', ...props }) {
    return (_jsx("div", { className: `${variantClasses[variant]} rounded-lg shadow-sm ${className}`, ...props, children: children }));
}
//# sourceMappingURL=Card.js.map